export default "__VITE_PUBLIC_ASSET__b6e2a5c0__"